import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

const SKIP_STATES = [
  "core-inputText--disabled",
  "core-inputText--error",
  "core-inputText--warning",
  "core-inputText--readonly",
  "core-inputText--loading",
];

export class CoreInputFilled implements Plugin {
  private field: HTMLInputElement | HTMLTextAreaElement | null;
  private inputHandler: () => void;

  constructor(private readonly element: HTMLElement) {
    this.field = this.element.querySelector(
      ".core-inputText__input, .core-inputText__textarea",
    );
    this.inputHandler = () => this.updateState();
  }

  init(): void {
    if (!this.field) return;
    this.updateState();
    this.field.addEventListener("input", this.inputHandler);
  }

  private updateState(): void {
    if (!this.field) return;
    if (SKIP_STATES.some((state) => this.element.classList.contains(state))) {
      return;
    }

    const hasValue = this.field.value.trim().length > 0;
    this.element.classList.toggle("core-inputText--filled", hasValue);
    this.element.classList.toggle("core-inputText--default", !hasValue);
  }

  destroy(): void {
    this.field?.removeEventListener("input", this.inputHandler);
  }
}

PluginRegistry.register("coreInputFilled", CoreInputFilled);
